import MyGiftCardItem from './MyGiftCardItem';

export default MyGiftCardItem;
